import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { z } from 'zod';
import formMessages from '~/components/form-messages';
import Spacings from '~/modules/ui-kit/spacings';
import messages from './messages';
import { useAppForm } from '../Form';

const schema = (intl: IntlShape) =>
  z.object({
    name: z
      .string({
        error: intl.formatMessage(formMessages.required),
      })
      .min(1, intl.formatMessage(formMessages.required)),
    address: z
      .string({
        error: intl.formatMessage(formMessages.required),
      })
      .min(1, intl.formatMessage(formMessages.required)),
    zip: z
      .string({
        error: intl.formatMessage(formMessages.required),
      })
      .min(1, intl.formatMessage(formMessages.required)),
    city: z
      .string({
        error: intl.formatMessage(formMessages.required),
      })
      .min(1, intl.formatMessage(formMessages.required)),
  });

type FormValues = {
  name: string;
  address?: string;
  zip?: string;
  city?: string;
};

type DepotFormProps = {
  initialValues?: FormValues;
  onSubmit: (values: FormValues) => void;
};

const DepotForm = (props: DepotFormProps) => {
  const intl = useIntl();
  const form = useAppForm({
    defaultValues: props.initialValues || {
      address: '',
      city: '',
      name: '',
      zip: '',
    },
    validators: {
      onChange: schema(intl),
    },
    onSubmit: ({ value }) => {
      props.onSubmit(value);
    },
  });
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
    >
      <Spacings.Inset>
        <Spacings.Stack scale="l">
          <form.AppField name="name">
            {(field) => (
              <field.TextField
                label={<FormattedMessage {...messages.name} />}
              />
            )}
          </form.AppField>
          <form.AppField name="address">
            {(field) => (
              <field.TextField
                label={<FormattedMessage {...messages.address} />}
              />
            )}
          </form.AppField>
          <form.AppField name="zip">
            {(field) => (
              <field.TextField label={<FormattedMessage {...messages.zip} />} />
            )}
          </form.AppField>
          <form.AppField name="city">
            {(field) => (
              <field.TextField
                label={<FormattedMessage {...messages.city} />}
              />
            )}
          </form.AppField>
          <div>
            <form.AppForm>
              <form.SubmitButton>
                <FormattedMessage {...formMessages.save} />
              </form.SubmitButton>
            </form.AppForm>
          </div>
        </Spacings.Stack>
      </Spacings.Inset>
    </form>
  );
};

export default DepotForm;
